import React from "react";
import { useTranslation } from "react-i18next";
import "./epk.css";
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";

const EPK = () => {
  const { t } = useTranslation();

  return (
    <BreathingBackground>
    <SectionWrapper>
    <article className="epk-page">
      {/* HERO */}
      <header className="epk-hero">
        <h1>Kujipy</h1>
        <p>{t("epk.tagline", "Mixe wind music · Dance · Living tradition")}</p>
      </header>
      <div className="epk-download">
        <a
            href="/Kujipy_EPK_International.pdf"
            target="_blank"
            className="editorial-link"
            rel="noopener noreferrer"
        >
            {t("common.downloadEpk")}
        </a>
      </div>

      {/* DESCRIPCIÓN */}
      <section className="epk-section">
        <h2>{t("epk.aboutTitle", "About the project")}</h2>
        <p>{t("epk.aboutText")}</p>
      </section>

      {/* ORIGEN */}
      <section className="epk-section highlight">
        <h2>{t("epk.originTitle", "Origin & cultural context")}</h2>
        <p>{t("epk.originText")}</p>
      </section>

      {/* EXPERIENCIA EN VIVO */}
      <section className="epk-section">
        <h2>{t("epk.liveTitle", "Live performance")}</h2>
        <p>{t("epk.liveText")}</p>
      </section>

      {/* REPERTORIO */}
      <section className="epk-section">
        <h2>{t("epk.repertoireTitle")}</h2>
        <p>{t("epk.repertoireIntro")}</p>

        <ul className="epk-repertoire">
          {(t("epk.repertoireList", { returnObjects: true }) as string[]).map(
            (piece, i) => (
              <li key={i}>{piece}</li>
            )
          )}
        </ul>
      </section>
      
      {/* NECESIDADES TÉCNICAS */}
      <section className="epk-section highlight">
        <h2>{t("epk.techTitle", "Technical requirements")}</h2>
        <p>{t("epk.techText")}</p>
      </section>

      {/* LINKS */}
      <section className="epk-section">
        <h2>{t("epk.mediaTitle", "Media & listening")}</h2>
        <div className="epk-links">
          <a href="https://www.youtube.com/@kujipyoficial8421" className="editorial-link" target="_blank" rel="noopener noreferrer">YouTube</a>
          <a href="https://open.spotify.com/artist/3tDuuuTkPprgYHtL7QsvXs" className="editorial-link" target="_blank" rel="noopener noreferrer">Spotify</a>
        </div>
      </section>

      {/* CONTACTO */}
      {/* <section className="epk-section contact">
        <h2>{t("epk.contactTitle", "Contact & booking")}</h2>

        <p>
          <strong>{t("epk.email", "Email")}:</strong>{" "}
          <a href="mailto:kujipy.suun@gmail.com" className="editorial-link">kujipy.suun@gmail.com</a>
        </p>

        <p>
          <strong>{t("epk.whatsapp", "WhatsApp")}:</strong>{" "}
          <a href="https://wa.me/522831169385" className="editorial-link" target="_blank" rel="noopener noreferrer">
            +52 283 116 9385
          </a>
        </p>

        <p>
          <strong>{t("epk.whatsapp", "WhatsApp")}:</strong>{" "}
          <a href="https://wa.me/522214418649" className="editorial-link" target="_blank" rel="noopener noreferrer">
            +52 221 441 8649
          </a>
        </p>

        <p>
          <strong>Website:</strong>{" "}
          <a href="https://www.kujipy.com" className="editorial-link" target="_blank" rel="noopener noreferrer">
            www.kujipy.com
          </a>
        </p>
      </section> */}
    </article>
    </SectionWrapper>
    </BreathingBackground>
  );
};

export default EPK;
